/* eslint-disable */
import React, { useRef, useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";

const srOnly = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

const ContactMain = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(form.current);
    const payload = Object.fromEntries(formData.entries());

    try {
      const response = await fetch("/api/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      toast.success("Message sent successfully! We'll get back to you within 24 hours.");
      form.current.reset();
    } catch (error) {
      toast.error("Failed to send message. Please try again or email us directly at info@evolvelab.co");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      {/* ================= Contact Main start =================*/}
      <Toaster position="bottom-center" reverseOrder={false} />
      <div className="contact-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="contact-page-inner bg-gray">
            <div className="section-title mb-4 pb-2">
              <h1 className="title">Get in Touch</h1>
              <p className="content mb-0">
                Have questions about our funding programs, accelerator services, or development solutions? 
                We're here to help. Send us a message and we'll get back to you within 24 hours.
              </p>
            </div>
            <form ref={form} onSubmit={sendEmail}>
              <div className="row">
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="name" style={srOnly}>Name</label>
                    <input
                      id="name"
                      name="user_name"
                      type="text"
                      placeholder="Enter Your Name."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="email" style={srOnly}>Email</label>
                    <input
                      id="email"
                      name="user_email"
                      type="email"
                      placeholder="Enter Your Email."
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="single-input-inner">
                    <label htmlFor="subject" style={srOnly}>Subject</label>
                    <input
                      id="subject"
                      name="subject"
                      type="text"
                      placeholder="Enter Your Subject."
                      required
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="single-input-inner">
                    <label htmlFor="message" style={srOnly}>Message</label>
                    <textarea
                      name="message"
                      id="message"
                      cols="1"
                      rows="5"
                      placeholder="Enter Your Message ..."
                      required
                    />
                  </div>
                </div>
                <div className="col-12 form-check">
                  <input className="form-check-input" type="checkbox" value="" id="optin" required aria-required="true" />
                  <label className="form-check-label" htmlFor="optin">I agree to <Link to="/terms">Terms &amp; Conditions</Link> provided by Evolvelab Solutions Inc. By providing my phone number, I agree to receive text messages from the business.</label>
                </div>

                <div className="col-12 text-center">
                  <button
                    className="btn btn-main btn-base border-radius-5"
                    type="submit"
                    disabled={isSubmitting}
                    style={{ minWidth: '150px' }}
                  >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* contact list */}
      <div className="contact-page-list">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="media single-contact-list">
                <div className="media-left">
                  <img src="assets/img/icon/13.svg" alt="Phone contact icon" />
                </div>
                <div className="media-body">
                  <h5>Contact Us</h5>
                  <h6>+1 604-767-0944</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="media single-contact-list">
                <div className="media-left">
                  <img src="assets/img/icon/14.svg" alt="Email contact icon" />
                </div>
                <div className="media-body">
                  <h5>Your Email</h5>
                  <h6>info@evolvelab.co</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="media single-contact-list">
                <div className="media-left">
                  <img src="assets/img/icon/15.svg" alt="Location pin icon" />
                </div>
                <div className="media-body">
                  <h5>Location</h5>
                  <h6>1055 W Georgia St, Vancouver, BC V6E 3P2</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Map  */}
      <div className="contact-g-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2602.673615100131!2d-123.11137762411236!3d49.28258147076223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486717994206c61%3A0x5625c9f83d97c055!2s151%20W%20Hastings%20St%2C%20Vancouver%2C%20BC%20V6B%201H4!5e0!3m2!1sen!2sca!4v1689195559562!5m2!1sen!2sca" />
      </div>
      

      {/* ================= Contact Main End =================*/}
    </>
  );
};

export default ContactMain;
